module.exports = __webpack_public_path__ + "static/media/scrap-rail.69257e8d.svg";